module.exports = __webpack_public_path__ + "img/logout.f60bfd84.png";